var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.375H11.0938L17.125 6.40625V18C17.125 18.8975 16.3975 19.625 15.5 19.625H4.5C3.60254 19.625 2.875 18.8975 2.875 18V2C2.875 1.10254 3.60254 0.375 4.5 0.375Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5V5C11 5.82843 11.6716 6.5 12.5 6.5H17",
    stroke: "#C8D2E1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 12.25,
    height: 8,
    rx: 1,
    fill: "#FF1607"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76615 15.5V11.8636H3.20081C3.47661 11.8636 3.71158 11.9163 3.90571 12.0217C4.09984 12.1258 4.2478 12.2708 4.3496 12.4567C4.45258 12.6413 4.50408 12.8544 4.50408 13.0959C4.50408 13.3374 4.45199 13.5504 4.34783 13.7351C4.24366 13.9197 4.09274 14.0636 3.89506 14.1665C3.69856 14.2695 3.46063 14.321 3.18128 14.321H2.26686V13.7049H3.05699C3.20495 13.7049 3.32687 13.6795 3.42275 13.6286C3.51982 13.5765 3.59202 13.5049 3.63937 13.4137C3.68791 13.3214 3.71217 13.2154 3.71217 13.0959C3.71217 12.9751 3.68791 12.8698 3.63937 12.7798C3.59202 12.6887 3.51982 12.6183 3.42275 12.5685C3.32569 12.5176 3.20258 12.4922 3.05344 12.4922H2.53497V15.5H1.76615ZM6.19252 15.5H4.90345V11.8636H6.20317C6.56894 11.8636 6.8838 11.9364 7.14777 12.082C7.41174 12.2264 7.61475 12.4342 7.75679 12.7053C7.90002 12.9763 7.97164 13.3007 7.97164 13.6783C7.97164 14.0571 7.90002 14.3826 7.75679 14.6548C7.61475 14.9271 7.41056 15.136 7.14422 15.2816C6.87907 15.4272 6.56183 15.5 6.19252 15.5ZM5.67227 14.8413H6.16056C6.38783 14.8413 6.579 14.801 6.73406 14.7205C6.89031 14.6388 7.0075 14.5128 7.08563 14.3423C7.16494 14.1707 7.20459 13.9493 7.20459 13.6783C7.20459 13.4096 7.16494 13.19 7.08563 13.0195C7.0075 12.8491 6.89091 12.7236 6.73584 12.6431C6.58077 12.5626 6.3896 12.5224 6.16233 12.5224H5.67227V14.8413ZM8.44115 15.5V11.8636H10.8488V12.4975H9.20997V13.364H10.689V13.9979H9.20997V15.5H8.44115Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.05e22a9e1b94361d199de99f60368482.svg";
export { ForwardRef as ReactComponent };